export default __webpack_public_path__ + "5fe7028ca213303800071ecc3c7d22e8.svg";